import { useCallback } from 'react';
import {
  DISCOVERY_PARAMS,
  DISCOVERY_TAB,
  isDiscoverySubView,
  LIST_PARAMS,
  withoutParams,
  type DiscoverySubView,
} from './search';
import { useCampaignSearchParam } from './useCampaignSearchParam';

const DEFAULT_DISCOVERY_VIEW: DiscoverySubView = 'find';

const CLEARED_ON_SWITCH = [...DISCOVERY_PARAMS, ...LIST_PARAMS].filter((param) => param !== 'sub');

export function resolveDiscoverySubView(
  tab: string | undefined,
  sub: string | undefined,
): DiscoverySubView | null {
  if (tab !== DISCOVERY_TAB) return null;
  return isDiscoverySubView(sub) ? sub : DEFAULT_DISCOVERY_VIEW;
}

export function useDiscoverySubParam() {
  const [tab] = useCampaignSearchParam('tab');
  const [sub, writeSub] = useCampaignSearchParam('sub');
  const setSub = useCallback(
    (next: DiscoverySubView) =>
      writeSub(next, { with: { ...withoutParams(CLEARED_ON_SWITCH), tab: DISCOVERY_TAB } }),
    [writeSub],
  );
  return { sub: resolveDiscoverySubView(tab, sub), setSub };
}
